import { createFileRoute } from '@tanstack/react-router';
import RemindersForm from '../../components/Reminders/RemindersForm';
import {
  PERMISSION_REMINDERS,
  PERMISSION_REMINDERS_OWNED_BY_USER,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/reminders/add')({
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [PERMISSION_REMINDERS, PERMISSION_REMINDERS_OWNED_BY_USER],
      ['create'],
      '/unauthorized',
      context
    );
    return {
      ...context,
      documentTitle: { main: 'reminderForm.newReminderTitle' },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AddReminderRoute,
});

// RemindersForm is self-contained (reads add/edit + id from the URL).
function AddReminderRoute() {
  return <RemindersForm />;
}
